/* eslint-disable */
export default {
  contactDetails: '联系人详细信息',
  loadingContact: '正在加载联系人…',
  contactNotFound: '未找到联系人。',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
